import { Box, Typography } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import Header from '../../components/Header';

import { useTranslation } from '../../hooks/useTranslation';
import { useNavigate } from 'react-router-dom';
import { DataContext } from '../../contexts/DataContext';
import PrimaryButton from '../../components/PrimaryButton';
import FloatingActions from '../../components/FloatingActions';
import CountrySelector from '../../components/CountrySelector';
import { useFlow } from '../../contexts/FlowContext';

function CountryPage() {
  const { t } = useTranslation();
  const { getBasePath, flowNumber } = useFlow();
  const navigate = useNavigate();
  const { steps, currentStep, data, setData, setCurrentStep, trackEvent } =
    useContext(DataContext);
  const onSubmit = () => {
    console.log('data', data);
    console.log(currentStep, ' currentStep');

    if (data?.country?.length <= 0) setData({ ...data, country: 'luxembourg' });
    else {
      if (data?.country === 'luxembourg') setCurrentStep(currentStep + 1);
      else {
        //setCurrentStep(currentStep + 1);
        setCurrentStep(flowNumber === 1 ? 6 : (flowNumber === 2 ? 5 : 2));
      }
    }
  };
  useEffect(() => {
    if (trackEvent) trackEvent({ nav_to_country_residence: 1 });
  }, [trackEvent]);

  return (
    <Box
      sx={{
        displayl: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'space-between',
        gap: '0px',
        background: '#F6F4F0',
      }}
    >
      <Header steps={steps} currentStep={currentStep} />
      <div
        style={{
          marginTop: '83px',
          display: 'flex',
          flexDirection: 'column',
          paddingInline: '24px',
          alignItems: 'stretch',
        }}
      >
        <Typography
          sx={{
            fontSize: '32px',
            fontWeight: '700',
            lineHeight: '38.46px',
          }}
        >
          {t('countryPage.title')}
        </Typography>
        <Box sx={{ marginTop: '48px' }}>
          <CountrySelector
            isError={() => data?.errors?.country}
            setData={setData}
            data={data}
          />
        </Box>
      </div>
      <FloatingActions childrenStyle={{}}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '8px',
            paddingInline: '24px',
          }}
        >
          <button
            onClick={() => navigate(`${getBasePath()}/`)}
            style={{
              outline: 'none',
              border: 'none',
              borderRadius: '50%',
              width: '57px',
              height: '57px',
              padding: 0,
              cursor: 'pointer',
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="57"
              height="57"
              viewBox="0 0 57 57"
              fill="none"
            >
              <rect
                opacity="0.1"
                width="57"
                height="57"
                rx="28.5"
                transform="matrix(-1 0 0 1 57 0)"
                fill="#44546A"
              />
              <path
                d="M35 29H22M22 29L27.2 24M22 29L27.2 34"
                stroke="#44546A"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <PrimaryButton
            style={{ flex: 1 }}
            disabled={data?.isOtherCountry && data?.country?.length < 3}
            onClick={onSubmit}
          >
            {t('continue')}
          </PrimaryButton>
        </div>
      </FloatingActions>
    </Box>
  );
}

export default CountryPage;
